export function removeLFromSignal(signalName: string): string {
  const idx = signalName.indexOf("(L)");
  if (idx >= 0) {
    signalName = signalName.slice(0, idx).trim();
  }
  return signalName;
}
